module.exports = __webpack_public_path__ + "img/矩形-蓝色.fb789706.png";